<template>
    <b-modal
        hide-footer
        ref="modal-view"
        size="xl"
        :title="modelId > 0 ? 'Edición cierre de venta' : 'Nuevo cierre de venta'"
    >
        <b-overlay :show="loading" no-wrap></b-overlay>
        <b-tabs no-fade pills card small vertical nav-class="nav-style">
            <b-tab title="General" active>
                <b-form @submit="onSubmit">
                    <b-form-row>
                        <b-form-group :disabled="unableEdit" class="col-lg-8" label="Descripción">
                            <b-form-input type="text" size="sm" v-model="modelInfo.description" />
                        </b-form-group>

                        <b-form-group :disabled="unableEdit" class="col-lg-4" label="Estado">
                            <b-form-radio-group v-model="modelInfo.status" name="status">
                                <b-form-radio value="active">Activo</b-form-radio>
                                <b-form-radio value="inactive">Inactivo</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>

                        <!-- ZonedArea master -->
                        <b-form-group :disabled="unableEdit" class="col-lg-6" label="Área de operación (opcional)">
                            <b-form-select
                                size="sm"
                                v-model="zonedAreaSelected"
                                :options="zonedAreaOpts"
                                @change="onZonedAreaChange"
                            />
                            <small class="text-muted">Si se deja vacío, aplica a todas las áreas.</small>
                        </b-form-group>

                        <!-- Zones within selected ZonedArea -->
                        <b-form-group :disabled="unableEdit || !zonedAreaSelected" class="col-lg-6" label="Zonas (opcional)">
                            <multiselect
                                :disabled="unableEdit || !zonedAreaSelected"
                                v-model="zonesSelected"
                                :options="zonesOpts"
                                :multiple="true"
                                label="text"
                                track-by="value"
                                placeholder="Todas las zonas del área"
                                :taggable="false"
                            />
                            <small class="text-muted">Si se deja vacío, aplica a todas las zonas del área.</small>
                        </b-form-group>

                        <!-- Schedule -->
                        <b-form-group :disabled="unableEdit" class="col-lg-3" label="Horario inicio (opcional)">
                            <b-form-input type="time" size="sm" v-model="modelInfo.scheduleStart" />
                            <small class="text-muted">Vacío = todo el día.</small>
                        </b-form-group>

                        <b-form-group :disabled="unableEdit" class="col-lg-3" label="Horario fin (opcional)">
                            <b-form-input type="time" size="sm" v-model="modelInfo.scheduleEnd" />
                        </b-form-group>

                        <!-- Service categories -->
                        <b-form-group :disabled="unableEdit" class="col-lg-6" label="Categorías de servicio (opcional)">
                            <multiselect
                                :disabled="unableEdit"
                                v-model="serviceCategoriesSelected"
                                :options="serviceCategoriesGroupedOpts"
                                :multiple="true"
                                group-values="options"
                                group-label="group"
                                :group-select="true"
                                label="text"
                                track-by="value"
                                placeholder="Todas las categorías"
                                :taggable="false"
                            />
                            <small class="text-muted">Si se deja vacío, aplica a todas las categorías.</small>
                        </b-form-group>

                        <!-- Sales channels -->
                        <b-form-group :disabled="unableEdit" class="col-lg-6" label="Canales de venta (opcional)">
                            <multiselect
                                :disabled="unableEdit"
                                v-model="salesChannelsSelected"
                                :options="salesChannelsGroupedOpts"
                                :multiple="true"
                                group-values="options"
                                group-label="group"
                                :group-select="true"
                                label="text"
                                track-by="value"
                                placeholder="Todos los canales"
                                :taggable="false"
                            />
                            <small class="text-muted">Si se deja vacío, aplica a todos los canales de venta.</small>
                        </b-form-group>
                    </b-form-row>

                    <hr />
                    <h6>Rangos de fechas <span class="text-danger">*</span></h6>
                    <div v-for="(range, index) in modelInfo.dates" :key="index" class="border rounded p-2 mb-2">
                        <b-form-row class="align-items-end">
                            <b-form-group :disabled="unableEdit" class="col-5 mb-0" label="Fecha inicio">
                                <b-form-input type="date" :min="modelId > 0 ? null : today" size="sm" v-model="range.startDate" required />
                            </b-form-group>
                            <b-form-group :disabled="unableEdit" class="col-5 mb-0" label="Fecha fin">
                                <b-form-input type="date" :min="modelId > 0 ? null : today" size="sm" v-model="range.endDate" required />
                            </b-form-group>
                            <div class="col-2 mb-2">
                                <b-button
                                    v-if="!unableEdit && modelInfo.dates.length > 1"
                                    size="sm"
                                    variant="danger"
                                    @click="removeDate(index)"
                                >
                                    <md-icon icon="delete" />
                                </b-button>
                            </div>
                        </b-form-row>
                    </div>

                    <b-button v-if="!unableEdit" size="sm" variant="outline-primary" @click="addDate" class="mb-3">
                        <md-icon icon="add" /> Agregar rango de fechas
                    </b-button>

                    <div class="text-right mt-2">
                        <b-button :disabled="unableEdit" variant="primary" type="submit">
                            {{ modelId > 0 ? 'Actualizar' : 'Guardar' }}
                        </b-button>
                    </div>
                </b-form>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: { Multiselect },
    props: {
        unableEdit: Boolean,
        successCallback: {
            type: Function,
            required: false,
            default: () => {}
        },
    },
    data() {
        return {
            modelId: -1,
            loading: false,
            modelInfo: this.defaultModel(),
            zonedAreaSelected:         null,
            zonesSelected:             [],
            serviceCategoriesSelected: [],
            salesChannelsSelected:     [],
        }
    },
    computed: {
        today() {
            const pad = n => String(n).padStart(2, '0')
            const d = new Date()
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        },
        zonedAreaOpts() {
            return [
                { value: null, text: 'Todas las áreas' },
                ...this.$root.auxVars.masterZonedAreasOpts.map(m => ({ value: m.id, text: m.name }))
            ]
        },
        zonesOpts() {
            if (!this.zonedAreaSelected) return []
            const master = this.$root.auxVars.masterZonedAreasOpts.find(m => m.id === this.zonedAreaSelected)
            return master ? master.zones.map(z => ({ value: z.id, text: z.name })) : []
        },
        serviceCategoriesOpts() {
            return this.$root.auxVars.serviceTypesCategoriesOpts.map(c => ({ value: c.id, text: c.name }))
        },
        serviceCategoriesGroupedOpts() {
            return [{ group: 'SELECT ALL', options: this.serviceCategoriesOpts }]
        },
        salesChannelsOpts() {
            return this.$root.auxVars.salesChannelsOpts.map(c => ({ value: c.id, text: c.text }))
        },
        salesChannelsGroupedOpts() {
            return [{ group: 'SELECT ALL', options: this.salesChannelsOpts }]
        },
    },
    methods: {
        defaultModel() {
            return {
                description:   '',
                status:        'active',
                scheduleStart: null,
                scheduleEnd:   null,
                dates:         [this.defaultDateRange()],
            }
        },
        defaultDateRange() {
            return { startDate: '', endDate: '' }
        },
        isoToDate(dateStr) {
            return dateStr ? dateStr.substring(0, 10) : ''
        },
        onZonedAreaChange() {
            this.zonesSelected = []
        },
        addDate() {
            this.modelInfo.dates.push(this.defaultDateRange())
        },
        removeDate(index) {
            this.modelInfo.dates.splice(index, 1)
        },
        loadModel(id) {
            this.modelId = id
            this.$refs['modal-view'].show()
            this.fetchModel()
        },
        fetchModel() {
            if (this.modelId > 0) {
                this.loading = true
                this.$root.api.get(`/stop-sales/${this.modelId}`).then(res => {
                    this.$emit('update:unableEdit', !this.$hasPermission('stopSale.edit'))
                    const data = res.data
                    this.modelInfo = {
                        description:   data.description || '',
                        status:        data.status,
                        scheduleStart: data.scheduleStart ? data.scheduleStart.substring(0, 5) : null,
                        scheduleEnd:   data.scheduleEnd   ? data.scheduleEnd.substring(0, 5)   : null,
                        dates: data.dates.map(d => ({
                            startDate: this.isoToDate(d.startDate),
                            endDate:   this.isoToDate(d.endDate),
                        })),
                    }
                    this.zonedAreaSelected         = data.zonedAreaId || null
                    this.zonesSelected             = (data.zones || []).map(z => ({ value: z.id, text: z.name }))
                    this.serviceCategoriesSelected = (data.serviceTypeCategories || []).map(c => ({ value: c.id, text: c.name }))
                    this.salesChannelsSelected     = (data.salesChannels || []).map(c => ({ value: c.id, text: c.code }))
                }).catch(this.$root.handleRequestError)
                .finally(() => { this.loading = false })
            } else {
                this.modelInfo                 = this.defaultModel()
                this.zonedAreaSelected         = null
                this.zonesSelected             = []
                this.serviceCategoriesSelected = []
                this.salesChannelsSelected     = []
                this.loading = false
            }
        },
        onSubmit(event) {
            event.preventDefault()
            this.loading = true

            const payload = {
                description:           this.modelInfo.description,
                status:                this.modelInfo.status,
                zonedAreaId:           this.zonedAreaSelected || null,
                zones:                 this.zonesSelected.map(z => z.value),
                scheduleStart:         this.modelInfo.scheduleStart || null,
                scheduleEnd:           this.modelInfo.scheduleEnd   || null,
                serviceTypeCategories: this.serviceCategoriesSelected.map(c => c.value),
                salesChannels:         this.salesChannelsSelected.map(c => c.value),
                dates: this.modelInfo.dates.map(d => ({
                    startDate: d.startDate,
                    endDate:   d.endDate,
                })),
            }

            const request = this.modelId > 0
                ? this.$root.api.put(`/stop-sales/${this.modelId}`, payload)
                : this.$root.api.post('/stop-sales', payload)

            request.then(res => {
                if (res.data.error) {
                    this.$root.showAlert(res.data.error, { variant: 'warning' })
                    return
                }
                this.$root.showAlert('OK!')
                if (res.data.id) this.loadModel(res.data.id)
                this.successCallback(res)
            }).catch(this.$root.handleRequestError)
            .finally(() => { this.loading = false })
        },
    },
}
</script>
